import { AuditStatus } from './status'
import { User } from './user'
import { AreaModel, Managers } from './area'
import { SchoolModel } from './school'

export const DealersOrderBy: {
  [key: string]: string;
} = {
  createdAt: 'CREATED_AT',
  'managers.modifiedBy.id': 'CREATOR_ID',
  email: 'EMAIL',
  level: ' LEVEL',
  'managers.createdBy.id': 'MODIFIER_ID',
  storePhone: ' PHONE',
  realname: 'REALNAME',
  status: 'STATUS',
  updatedAt: 'UPDATED_AT',
  'user.username': 'USERNAME'
}

export interface DealerModel {
  address: string;
  areas: AreaModel[];
  covers: string;
  applyDate: string;
  auditDate: string;
  createdAt: string;
  id: number;
  level: number;
  managers: Managers;
  openId: string;
  parentId: number;
  realname: string;
  schools: SchoolModel[];
  status: AuditStatus;
  storeName: string;
  updatedAt: string;
  user: User;
  goodRelations: [];
  ifStoreOpening: boolean;
}
